module.exports = __webpack_public_path__ + "static/media/IMG_0002.7d51c81e.jpg";